module.exports = __webpack_public_path__ + "img/cdiac.947094eb.svg";